// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"abd6a14e","239":"b0f09e53","453":"dadaf75d","455":"97cf2d1c"}[chunkId] + ".chunk.js";
};